export const languageCode = [
  {
    name: "Afrikaans (South Africa)",
    code: {
      amazon: "",
      google: "af-ZA",
      azure: "af-ZA",
      openAI: "af-ZA",
      soundhound: "",
    },
  },
  {
    name: "Albanian (Albania)",
    code: {
      amazon: "",
      google: "",
      azure: "sq-AL",
      openAI: "ar-SA",
      soundhound: "",
    },
  },
  {
    name: "Amharic (Ethiopia)",
    code: {
      amazon: "",
      google: "",
      azure: "am-ET",
      openAI: "hy-AM",
      soundhound: "",
    },
  },
  {
    name: "Arabic",
    code: {
      amazon: "arb",
      google: "ar-XA",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Algeria)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-DZ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Bahrain)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-BH",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Egypt)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-EG",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Iraq)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-IQ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Jordan)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-JO",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Kuwait)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-KW",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Lebanon)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-LB",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Libya)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-LY",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Morocco)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-MA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Oman)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-OM",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Qatar)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-QA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Saudi Arabia)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-SA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Syria)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-SY",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Tunisia)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-TN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (United Arab Emirates)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-AE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Arabic (Yemen)",
    code: {
      amazon: "",
      google: "",
      azure: "ar-YE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Armenian (Armenia)",
    code: {
      amazon: "",
      google: "",
      azure: "hy-AM",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Azerbaijani (Latin, Azerbaijan)",
    code: {
      amazon: "",
      google: "",
      azure: "az-AZ",
      openAI: "az-AZ",
      soundhound: "",
    },
  },
  {
    name: "Bangla (Bangladesh)",
    code: {
      amazon: "",
      google: "",
      azure: "bn-BD",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Basque",
    code: {
      amazon: "",
      google: "eu-ES",
      azure: "eu-ES",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Belarusian",
    code: {
      amazon: "",
      google: "",
      azure: "",
      openAI: "be-BY",
      soundhound: "",
    },
  },
  {
    name: "Bengali (India)",
    code: {
      amazon: "",
      google: "bn-IN",
      azure: "bn-IN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Bosnian (Bosnia and Herzegovina)",
    code: {
      amazon: "",
      google: "",
      azure: "bs-BA",
      openAI: "bs-BA",
      soundhound: "",
    },
  },
  {
    name: "Bulgarian (Bulgaria)",
    code: {
      amazon: "",
      google: "bg-BG",
      azure: "bg-BG",
      openAI: "bg-BG",
      soundhound: "",
    },
  },
  {
    name: "Burmese (Myanmar)",
    code: {
      amazon: "",
      google: "",
      azure: "my-MM",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Catalan (Spain)",
    code: {
      amazon: "",
      google: "ca-ES",
      azure: "ca-ES",
      openAI: "ca-ES",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Cantonese, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "yue-CN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Cantonese, Traditional)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-HK",
      openAI: "",
      soundhound: "zh",
    },
  },
  {
    name: "Chinese (Hong Kong)",
    code: {
      amazon: "",
      google: "yue-HK",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Jilu Mandarin, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-CN-shandong",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Mandarin, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-CN",
      openAI: "zh-CN",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Northeastern Mandarin, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-CN-liaoning",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Southwestern Mandarin, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-CN-sichuan",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Taiwanese Mandarin, Traditional)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-TW",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Wu, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "wuu-CN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Zhongyuan Mandarin Henan, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-CN-henan",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese (Zhongyuan Mandarin Shaanxi, Simplified)",
    code: {
      amazon: "",
      google: "",
      azure: "zh-CN-shaanxi",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Chinese Traditional",
    code: {
      amazon: "cmn-CN",
      google: "",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Croatian (Croatia)",
    code: {
      amazon: "",
      google: "",
      azure: "hr-HR",
      openAI: "hr-HR",
      soundhound: "",
    },
  },
  {
    name: "Czech (Czechia)",
    code: {
      amazon: "",
      google: "cs-CZ",
      azure: "cs-CZ",
      openAI: "cs-CZ",
      soundhound: "",
    },
  },
  {
    name: "Danish (Denmark)",
    code: {
      amazon: "da-DK",
      google: "da-DK",
      azure: "da-DK",
      openAI: "da-DK",
      soundhound: "",
    },
  },
  {
    name: "Dutch (Belgium)",
    code: {
      amazon: "",
      google: "nl-BE",
      azure: "nl-BE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Dutch (Netherlands)",
    code: {
      amazon: "nl-NL",
      google: "nl-NL",
      azure: "nl-NL",
      openAI: "nl-NL",
      soundhound: "",
    },
  },
  {
    name: "English (Australia)",
    code: {
      amazon: "en-AU",
      google: "en-AU",
      azure: "en-AU",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Canada)",
    code: {
      amazon: "",
      google: "",
      azure: "en-CA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Hong Kong SAR)",
    code: {
      amazon: "",
      google: "",
      azure: "en-HK",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (India)",
    code: {
      amazon: "en-IN",
      google: "en-IN",
      azure: "en-IN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Ireland)",
    code: {
      amazon: "",
      google: "",
      azure: "en-IE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Kenya)",
    code: {
      amazon: "",
      google: "",
      azure: "en-KE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (New Zealand)",
    code: {
      amazon: "",
      google: "",
      azure: "en-NZ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Nigeria)",
    code: {
      amazon: "",
      google: "",
      azure: "en-NG",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Philippines)",
    code: {
      amazon: "",
      google: "",
      azure: "en-PH",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Singapore)",
    code: {
      amazon: "",
      google: "",
      azure: "en-SG",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (South Africa)",
    code: {
      amazon: "",
      google: "",
      azure: "en-ZA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (Tanzania)",
    code: {
      amazon: "",
      google: "",
      azure: "en-TZ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (United Kingdom)",
    code: {
      amazon: "en-GB",
      google: "en-GB",
      azure: "en-GB",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "English (United States)",
    code: {
      amazon: "en-US",
      google: "en-US",
      azure: "en-US",
      openAI: "en-US",
      soundhound: "en",
    },
  },
  {
    name: "English, British",
    code: {
      amazon: "en-GB-WLS",
      google: "",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Estonian (Estonia)",
    code: {
      amazon: "",
      google: "",
      azure: "et-EE",
      openAI: "et-EE",
      soundhound: "",
    },
  },
  {
    name: "Filipino (Philippines)",
    code: {
      amazon: "",
      google: "fil-PH",
      azure: "fil-PH",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Finnish (Finland)",
    code: {
      amazon: "",
      google: "fi-FI",
      azure: "fi-FI",
      openAI: "fi-FI",
      soundhound: "",
    },
  },
  {
    name: "French (Belgium)",
    code: {
      amazon: "",
      google: "",
      azure: "fr-BE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "French (Canada)",
    code: {
      amazon: "fr-CA",
      google: "fr-CA",
      azure: "fr-CA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "French (France)",
    code: {
      amazon: "fr-FR",
      google: "fr-FR",
      azure: "fr-FR",
      openAI: "fr-FR",
      soundhound: "",
    },
  },
  {
    name: "French (Switzerland)",
    code: {
      amazon: "",
      google: "",
      azure: "fr-CH",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Galician",
    code: {
      amazon: "",
      google: "gl-ES",
      azure: "gl-ES",
      openAI: "gl-ES",
      soundhound: "",
    },
  },
  {
    name: "Georgian (Georgia)",
    code: {
      amazon: "",
      google: "",
      azure: "ka-GE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "German (Austria)",
    code: {
      amazon: "de-AT",
      google: "",
      azure: "de-AT",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "German (Germany)",
    code: {
      amazon: "de-DE",
      google: "de-DE",
      azure: "de-DE",
      openAI: "de-DE",
      soundhound: "",
    },
  },
  {
    name: "German (Switzerland)",
    code: {
      amazon: "",
      google: "",
      azure: "de-CH",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Greek (Greece)",
    code: {
      amazon: "",
      google: "el-GR",
      azure: "el-GR",
      openAI: "el-GR",
      soundhound: "",
    },
  },
  {
    name: "Gujarati (India)",
    code: {
      amazon: "",
      google: "gu-IN",
      azure: "gu-IN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Hebrew (Israel)",
    code: {
      amazon: "",
      google: "he-IL",
      azure: "he-IL",
      openAI: "he-IL",
      soundhound: "",
    },
  },
  {
    name: "Hindi (India)",
    code: {
      amazon: "hi-IN",
      google: "hi-IN",
      azure: "hi-IN",
      openAI: "hi-IN",
      soundhound: "",
    },
  },
  {
    name: "Hungarian (Hungary)",
    code: {
      amazon: "",
      google: "hu-HU",
      azure: "hu-HU",
      openAI: "hu-HU",
      soundhound: "",
    },
  },
  {
    name: "Icelandic (Iceland)",
    code: {
      amazon: "is-IS",
      google: "is-IS",
      azure: "is-IS",
      openAI: "is-IS",
      soundhound: "",
    },
  },
  {
    name: "Indonesian (Indonesia)",
    code: {
      amazon: "",
      google: "id-ID",
      azure: "id-ID",
      openAI: "id-ID",
      soundhound: "",
    },
  },
  {
    name: "Irish (Ireland)",
    code: {
      amazon: "",
      google: "",
      azure: "ga-IE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Italian (Italy)",
    code: {
      amazon: "it-IT",
      google: "it-IT",
      azure: "it-IT",
      openAI: "it-IT",
      soundhound: "",
    },
  },
  {
    name: "Japanese (Japan)",
    code: {
      amazon: "ja-JP",
      google: "ja-JP",
      azure: "ja-JP",
      openAI: "ja-JP",
      soundhound: "ja",
    },
  },
  {
    name: "Javanese (Latin, Indonesia)",
    code: {
      amazon: "",
      google: "",
      azure: "jv-ID",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Kannada (India)",
    code: {
      amazon: "",
      google: "kn-IN",
      azure: "kn-IN",
      openAI: "kn-IN",
      soundhound: "",
    },
  },
  {
    name: "Kazakh (Kazakhstan)",
    code: {
      amazon: "",
      google: "",
      azure: "kk-KZ",
      openAI: "kk-KZ",
      soundhound: "",
    },
  },
  {
    name: "Khmer (Cambodia)",
    code: {
      amazon: "",
      google: "",
      azure: "km-KH",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Korean (Korea)",
    code: {
      amazon: "ko-KR",
      google: "ko-KR",
      azure: "ko-KR",
      openAI: "ko-KR",
      soundhound: "ko",
    },
  },
  {
    name: "Lao (Laos)",
    code: {
      amazon: "",
      google: "",
      azure: "lo-LA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Latvian (Latvia)",
    code: {
      amazon: "",
      google: "lv-LV",
      azure: "lv-LV",
      openAI: "lv-LV",
      soundhound: "",
    },
  },
  {
    name: "Lithuanian (Lithuania)",
    code: {
      amazon: "",
      google: "lt-LT",
      azure: "lt-LT",
      openAI: "lt-LT",
      soundhound: "",
    },
  },
  {
    name: "Macedonian (North Macedonia)",
    code: {
      amazon: "",
      google: "",
      azure: "mk-MK",
      openAI: "mk-MK",
      soundhound: "",
    },
  },
  {
    name: "Malay (Malaysia)",
    code: {
      amazon: "",
      google: "ms-MY",
      azure: "ms-MY",
      openAI: "ms-MY",
      soundhound: "",
    },
  },
  {
    name: "Malayalam (India)",
    code: {
      amazon: "",
      google: "ml-IN",
      azure: "ml-IN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Maltese (Malta)",
    code: {
      amazon: "",
      google: "",
      azure: "mt-MT",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Mandarin Chinese",
    code: {
      amazon: "",
      google: "cmn-CN",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Marathi (India)",
    code: {
      amazon: "",
      google: "mr-IN",
      azure: "mr-IN",
      openAI: "mr-IN",
      soundhound: "",
    },
  },
  {
    name: "Maori",
    code: {
      amazon: "",
      google: "",
      azure: "",
      openAI: "mi-NZ",
      soundhound: "",
    },
  },
  {
    name: "Mongolian",
    code: {
      amazon: "cmn-CN",
      google: "",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Mongolian (Mongolia)",
    code: {
      amazon: "",
      google: "",
      azure: "mn-MN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Nepali (Nepal)",
    code: {
      amazon: "",
      google: "",
      azure: "ne-NP",
      openAI: "ne-NP",
      soundhound: "",
    },
  },
  {
    name: "Norwegian (Norway)",
    code: {
      amazon: "",
      google: "no-NO",
      azure: "",
      openAI: "no-NO",
      soundhound: "",
    },
  },
  {
    name: "Norwegian Bokmål (Norway)",
    code: {
      amazon: "",
      google: "",
      azure: "nb-NO",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Pashto (Afghanistan)",
    code: {
      amazon: "",
      google: "",
      azure: "ps-AF",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Persian (Iran)",
    code: {
      amazon: "",
      google: "",
      azure: "fa-IR",
      openAI: "fa-IR",
      soundhound: "",
    },
  },
  {
    name: "Polish (Poland)",
    code: {
      amazon: "pl-PL",
      google: "pl-PL",
      azure: "pl-PL",
      openAI: "pl-PL",
      soundhound: "",
    },
  },
  {
    name: "Portuguese (Brazil)",
    code: {
      amazon: "pt-BR",
      google: "pt-BR",
      azure: "pt-BR",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Portuguese (Portugal)",
    code: {
      amazon: "pt-PT",
      google: "pt-PT",
      azure: "pt-PT",
      openAI: "pt-PT",
      soundhound: "",
    },
  },
  {
    name: "Punjabi (India)",
    code: {
      amazon: "",
      google: "pa-IN",
      azure: "",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Romanian (Romania)",
    code: {
      amazon: "ro-RO",
      google: "ro-RO",
      azure: "ro-RO",
      openAI: "ro-RO",
      soundhound: "",
    },
  },
  {
    name: "Russian (Russia)",
    code: {
      amazon: "ru-RU",
      google: "ru-RU",
      azure: "ru-RU",
      openAI: "ru-RU",
      soundhound: "",
    },
  },
  {
    name: "Serbian (Cyrillic, Serbia)",
    code: {
      amazon: "",
      google: "sr-RS",
      azure: "sr-RS",
      openAI: "sr-RS",
      soundhound: "",
    },
  },
  {
    name: "Sinhala (Sri Lanka)",
    code: {
      amazon: "",
      google: "",
      azure: "si-LK",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Slovak (Slovakia)",
    code: {
      amazon: "",
      google: "sk-SK",
      azure: "sk-SK",
      openAI: "sk-SK",
      soundhound: "",
    },
  },
  {
    name: "Slovenian (Slovenia)",
    code: {
      amazon: "",
      google: "",
      azure: "sl-SI",
      openAI: "sl-SI",
      soundhound: "",
    },
  },
  {
    name: "Somali (Somalia)",
    code: {
      amazon: "",
      google: "",
      azure: "so-SO",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Argentina)",
    code: {
      amazon: "",
      google: "",
      azure: "es-AR",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Bolivia)",
    code: {
      amazon: "",
      google: "",
      azure: "es-BO",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Chile)",
    code: {
      amazon: "",
      google: "",
      azure: "es-CL",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Colombia)",
    code: {
      amazon: "",
      google: "",
      azure: "es-CO",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Costa Rica)",
    code: {
      amazon: "",
      google: "",
      azure: "es-CR",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Cuba)",
    code: {
      amazon: "",
      google: "",
      azure: "es-CU",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Dominican Republic)",
    code: {
      amazon: "",
      google: "",
      azure: "es-DO",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Ecuador)",
    code: {
      amazon: "",
      google: "",
      azure: "es-EC",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (El Salvador)",
    code: {
      amazon: "",
      google: "",
      azure: "es-SV",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Equatorial Guinea)",
    code: {
      amazon: "",
      google: "",
      azure: "es-GQ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Guatemala)",
    code: {
      amazon: "",
      google: "",
      azure: "es-GT",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Honduras)",
    code: {
      amazon: "",
      google: "",
      azure: "es-HN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Mexico)",
    code: {
      amazon: "es-MX",
      google: "",
      azure: "es-MX",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Nicaragua)",
    code: {
      amazon: "",
      google: "",
      azure: "es-NI",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Panama)",
    code: {
      amazon: "",
      google: "",
      azure: "es-PA",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Paraguay)",
    code: {
      amazon: "",
      google: "",
      azure: "es-PY",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Peru)",
    code: {
      amazon: "",
      google: "",
      azure: "es-PE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Puerto Rico)",
    code: {
      amazon: "",
      google: "",
      azure: "es-PR",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Spain)",
    code: {
      amazon: "es-ES",
      google: "es-ES",
      azure: "es-ES",
      openAI: "es-ES",
      soundhound: "",
    },
  },
  {
    name: "Spanish (United States)",
    code: {
      amazon: "es-US",
      google: "es-US",
      azure: "es-US",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Uruguay)",
    code: {
      amazon: "",
      google: "",
      azure: "es-UY",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Spanish (Venezuela)",
    code: {
      amazon: "",
      google: "",
      azure: "es-VE",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Sundanese (Indonesia)",
    code: {
      amazon: "",
      google: "",
      azure: "su-ID",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Swahili (Kenya)",
    code: {
      amazon: "",
      google: "",
      azure: "sw-KE",
      openAI: "sw-KE",
      soundhound: "",
    },
  },
  {
    name: "Swahili (Tanzania)",
    code: {
      amazon: "",
      google: "",
      azure: "sw-TZ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Swedish (Sweden)",
    code: {
      amazon: "sv-SE",
      google: "sv-SE",
      azure: "sv-SE",
      openAI: "sv-SE",
      soundhound: "",
    },
  },
  {
    name: "Tagalog",
    code: {
      amazon: "",
      google: "",
      azure: "",
      openAI: "tl-PH",
      soundhound: "",
    },
  },
  {
    name: "Tamil (India)",
    code: {
      amazon: "",
      google: "ta-IN",
      azure: "ta-IN",
      openAI: "ta-IN",
      soundhound: "",
    },
  },
  {
    name: "Tamil (Malaysia)",
    code: {
      amazon: "",
      google: "",
      azure: "ta-MY",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Tamil (Singapore)",
    code: {
      amazon: "",
      google: "",
      azure: "ta-SG",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Tamil (Sri Lanka)",
    code: {
      amazon: "",
      google: "",
      azure: "ta-LK",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Telugu (India)",
    code: {
      amazon: "",
      google: "te-IN",
      azure: "te-IN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Thai (Thailand)",
    code: {
      amazon: "",
      google: "th-TH",
      azure: "th-TH",
      openAI: "th-TH",
      soundhound: "",
    },
  },
  {
    name: "Turkish (Turkey)",
    code: {
      amazon: "",
      google: "tr-TR",
      azure: "tr-TR",
      openAI: "tr-TR",
      soundhound: "",
    },
  },
  {
    name: "Ukrainian (Ukraine)",
    code: {
      amazon: "",
      google: "uk-UA",
      azure: "uk-UA",
      openAI: "uk-UA",
      soundhound: "",
    },
  },
  {
    name: "Urdu (India)",
    code: {
      amazon: "",
      google: "",
      azure: "ur-IN",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Urdu (Pakistan)",
    code: {
      amazon: "",
      google: "",
      azure: "ur-PK",
      openAI: "ur-PK",
      soundhound: "",
    },
  },
  {
    name: "Uzbek (Latin, Uzbekistan)",
    code: {
      amazon: "",
      google: "",
      azure: "uz-UZ",
      openAI: "",
      soundhound: "",
    },
  },
  {
    name: "Vietnamese (Vietnam)",
    code: {
      amazon: "",
      google: "vi-VN",
      azure: "vi-VN",
      openAI: "vi-VN",
      soundhound: "",
    },
  },
  {
    name: "Welsh (United Kingdom)",
    code: {
      amazon: "cy-GB",
      google: "",
      azure: "cy-GB",
      openAI: "cy-GB",
      soundhound: "",
    },
  },
  {
    name: "Zulu (South Africa)",
    code: {
      amazon: "",
      google: "",
      azure: "zu-ZA",
      openAI: "",
      soundhound: "",
    },
  },
];
export const languageCodeSource = [
  {
    name: "Language Detection",
    code: {
      amazon: "detect",
      google: "detect",
      azure: "detect",
      openAI: "detect",
      soundhound: "detect",
    },
  },
  ...languageCode,
];
